import { observable } from '@/libs/state'
import type { Message, TopicView } from './domain/chat'

// Conversation list (with unread counts) and the active thread's messages.
// Both are server-derived; the hooks own refetch/poll and write here, the UI
// reads via useSelector.
const topics$ = observable<TopicView[]>([])
const activeTopicId$ = observable<string | null>(null)
const messages$ = observable<Message[]>([])
const replyingTo$ = observable<Message | null>(null)

export { topics$, activeTopicId$, messages$, replyingTo$ }
